export default __webpack_public_path__ + "static/media/userlogo.72cae964.png";